import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/auth/signin/signin.component';
import { UserRole } from './enums/enums';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './services/app/auth-guard/auth.guard';
import { PublicGuard } from './services/app/public-guard/public.guard';
import { DriverComponent } from './components/credentials/drivers/driver/driver.component';
import { AddDriverComponent } from './components/credentials/drivers/add-driver/add-driver.component';
import { AddVehicleComponent } from './components/credentials/vehicle/add-vehicle/add-vehicle.component';
import { AddCredentialCompanyComponent } from './components/credentials/credentials-company/add-credential-company/add-credential-company.component';
import { VehiclesComponent } from './components/credentials/vehicle/vehicles/vehicles.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { TripListComponent } from './components/distributions/trip-list/trip-list.component';
import { MarketplaceComponent } from './components/marketplace/marketplace/marketplace.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { ConfigurationComponent } from './components/configuration/configuration/configuration.component';
import { ListGpsComponent } from './components/list-gps/list-gps.component';
import { ListEventComponent } from './components/list-event/list-event.component';
import { TutorialsListComponent } from './components/tutorials/tutorials-list/tutorials-list.component';
import { BillingListComponent } from './components/billing/billing-list/billing-list.component';
import { AdjustmentFormComponent } from './components/billing/adjustment-form/adjustment-form.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { StatisticsComponent } from './components/statistics/statistics.component';

import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';

const routes: Routes = [
  { path: 'login', component: SigninComponent, canActivate: [PublicGuard] },

  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },

  {
    path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },

  // profile
  {
    path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },

  // Company
  {
    path: 'company',
    component: AddCredentialCompanyComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  // Driver
  {
    path: 'drivers',
    component: DriverComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'drivers/add',
    component: AddDriverComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'drivers/driver/:driverId/edit',
    component: AddDriverComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  // Vehicle
  {
    path: 'vehicles',
    component: VehiclesComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'vehicles/add',
    component: AddVehicleComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'vehicles/vehicle/:vehicleId/edit',
    component: AddVehicleComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips',
    component: TripListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
    // GPS
  {
    path: 'trips/gps',
    component: ListGpsComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  
  },
    // Event
  {
    path: 'trips/event',
    component: ListEventComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  
  },
  {
    path: 'marketplace',
    component: MarketplaceComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },

     //notifications
  {
    path: 'notifications',
    component: NotificationsComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  
  },

  //Reset Password
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    // }
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },

  // configuration
  {
    path: 'configuration',
    component: ConfigurationComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  
  },

  // billing

    {
    path: 'billing',
    component: BillingListComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'billing/:id/adjustTrip',
    component: AdjustmentFormComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/:id/adjustTrip',
    component: AdjustmentFormComponent,
      canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },

   // tutorials
  // support
  {
    path: 'support',
    redirectTo: 'support/tickets',
    pathMatch: 'full'
  },
  {
    path: 'support/tickets',
    component: SupportTicketsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/chats',
    component: SupportChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/add',
    component: AddSupportTicketComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/:id',
    component: TicketDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'academy',
    component: TutorialsListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
   {
    path: 'statistics',
    component: StatisticsComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
 

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
